import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { bytesToSizeNew, generateLineDetails, getImgSrc } from '../../services/common/CommonUtils';
import { getGlobalSettingValue,getItemOfSessionStorage,isContainAlphabet } from '../../services/common/utils';
import { useSelector } from 'react-redux';
import { redirecturl } from '../../services/common/redirect';
import { SELECTED_LANG } from '../../services/common/Constants';
function RemainingInfo({ linedetailsApi, infotype }) {

    const dataMapping = {
        'data': linedetailsApi?.data?.data?.response?.Internet,
        'voice': linedetailsApi?.data?.data?.response?.Minutes,
        'sms': linedetailsApi?.data?.data?.response?.Sms,
        'roaming': linedetailsApi?.data?.data?.response?.Roaming,
    }
    const infoObject = generateLineDetails(dataMapping[infotype]);

    let corepacks = [];
    let noncorepacks = [];
    let romingcorepacks = [];
    let roamingnoncorepacks = [];

    if (infotype == 'roaming') {
        roamingnoncorepacks = filterData(
            infoObject?.Services,
            'Bytes',
            'raomingcorepacks'
        );
        roamingnoncorepacks = filterData(
            infoObject?.Services,
            'Bytes',
            'roamingnoncorepacks'
        );
    } else {
        corepacks = filterData(infoObject?.Services, 'CORE_MYNET', 'corepacks');
        noncorepacks = filterData(
            infoObject?.Services,
            'CORE_MYNET',
            'noncorepacks'
        );
    }

    function filterData(data, type, filtertype) {
        if (filtertype == 'corepacks') {
            return data?.filter(x => x?.offertype === type) || [];
        } else if (filtertype == 'raomingcorepacks') {
            return data?.filter(x => x?.notation === type) || [];
        } else if (filtertype == 'roamingnoncorepacks') {
            return data?.filter(x => x?.notation !== type) || [];
        } else {
            return data?.filter(x => x?.offertype !== type) || [];
        }
    }

    const corepackslist = infotype == 'roaming' ? romingcorepacks : corepacks;
    const noncorepackslist = infotype == 'roaming' ? roamingnoncorepacks : noncorepacks;

    const netData = linedetailsApi?.data?.data?.response?.coremynet;
    const dataInfo = linedetailsApi?.data?.data?.response?.datainfo

    console.log("corepackslist:"+JSON.stringify(corepackslist))
    console.log("noncorepackslist:"+JSON.stringify(noncorepackslist))

    if (corepackslist?.length === 0 && noncorepackslist?.length === 0) {
        return <></>
    }

    return (
        <div>
            <div class="sprint14-hed-comp mt-4 mb-4 text-center">
                <img src={infoObject?.icon} alt="info-icon" /> <h6>{infoObject?.title || ''}</h6>
            </div>

            {
                corepackslist?.map((pack, index, arr) => {
                    return (
                        <div key={`core_${index}`} className={`white_card cs_padding_v1 mt-3 ${((index + 1) === arr.length && noncorepackslist.length === 0) ? 'mb-4' : ''}`}>
                            <RenderCardInfo data={pack} netData={netData}
                             dataInfo={dataInfo} infotype={infotype} type='rect'/>
                        </div>
                    )
                })
            }

           
            <div class="sprint14-new2col-row mt-3">
                               <div class="row row-cols-1 row-cols-md-3 g-3">
                {
                    noncorepackslist?.map((pack, index) => {
                        return (
                            
                            <div className='col'>
                                 <div class="card h-100">
                                   
                                            <div key={`noncore_${index}`} className={`flx-card-sp14 ${index === 0 || index === 1 ? '' : ''}`}>
                                            <RenderCardInfo data={pack} netData={netData} 
                                            dataInfo={dataInfo} infotype={infotype} type='square' />
                                            </div>
                            </div>
                             </div>
                           
                        )
                    })
                }
            </div>
            </div>
            
        </div>
    )
}

const RenderCardInfo = ({ data, netData, dataInfo, infotype,type }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const {
        utilityData: { globalSetting },
    } = useSelector((state) => state);
    const settingsArr = globalSetting
        ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
        : [];

    const percentage = parseFloat((data?.balance / data?.total) * 100 || 0);

    const getColorCode = (percentage) => {
        if (percentage > getGlobalSettingValue('dashboardhighpercentage', settingsArr)) {
            return getGlobalSettingValue('dashboardhighcolor', settingsArr);
        } else if (percentage > getGlobalSettingValue('dashboardmediumpercentage', settingsArr)) {
            return getGlobalSettingValue('dashboardmediumcolor', settingsArr);
        } else {
            return getGlobalSettingValue('dashboardlowcolor', settingsArr);
        }
    }

    const colorCode = getColorCode(percentage);

    const handleRedirect = (e, url) => {
        e.preventDefault();

        if (url) {
            redirecturl(url, navigate);
        } else {
            return
        }
    }

    const showExtra = data?.offertype == 'CORE_MYNET' ||
        (infotype == 'roaming' && data?.notation == 'Bytes')

    // const used = `${parseFloat(bytesToSizeNew(data?.balance))} ${data?.rnnotation}`;
    // const total = `${parseFloat(bytesToSizeNew(data?.total))} ${data?.rntotalnotation}`;

    let used = '';
    let total = '';

    if(data?.rnnotation?.toLowerCase() == 'min' || data?.rnnotation?.toLowerCase() == 'sms'){
        used = `${parseFloat(data?.balance)} ${data?.rnnotation}`;
        total = `${parseFloat(data?.total)} ${data?.rntotalnotation}`;
    }else{
        used = `${parseFloat(bytesToSizeNew(data?.balance))} ${data?.rnnotation}`;
        total = `${parseFloat(bytesToSizeNew(data?.total))} ${data?.rntotalnotation}`;
    }

    const imagePath = data?.imageurl || '/assets/images/app.png';
    const isServerUrl = (data?.imageurl) ? true : false;

    return (
        <>
         {
           type === 'rect' && (<>
            <div class="sprint14-2row sprint14-cr-roamingd">
            <div class="profile_info_desc">
                <div class="d-flex align-items-center">
                    <img src={getImgSrc(imagePath, isServerUrl)} alt="icon" width={45} />
                    <div class="s-text">
                        <h5>{data?.rnheader}</h5>
                        {
                            showExtra && (
                                <p class="m-0 p-0"> {data?.packtitle} </p>
                            )
                        }
                    </div>
                </div>
            </div>

            {
                !data?.isunlimited ? (
                    <div class="sprint14-progress-bar">
                        <div style={{direction: isContainAlphabet(used) ? "ltr" : ""}}>
                            {used} <span> {`${total ? `/ ${total}` : ''}`} </span>
                        </div>
                        <div class="progress" role="progressbar">
                            <div class="progress-bar" style={{ width: `${percentage}%` || '0%', backgroundColor: colorCode }}></div>
                        </div>
                        <p>{dataInfo?.expiresonlabel || t('expires_on')} {data?.endDate}</p>
                    </div>
                ) : (
                    <div className='mt-1 sprint14-progress-bar'>
                        <div class="mb-1">
                            <img src={getImgSrc('/assets/images/infinityunlimited.png')} alt="unlimited" width="30px" /> {t('unlimited')}
                        </div>
                        <p>{dataInfo?.expiresonlabel || t('expires_on')} {data?.endDate}</p>
                    </div>
                )
            }


            {
                infotype === 'data' && showExtra && (
                    <>
                        <hr />
                        <div className='flex_grp_between'>
                        <div>
                            <a class="hyperlink" href="#" onClick={(e) => handleRedirect(e, dataInfo?.btnurl)}>
                                {dataInfo?.btntext}
                                <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow" />
                            </a>
                        </div>

                        {
                            netData?.issharable?.toLowerCase() === 'true' &&
                            netData?.isdisabledatashare.toLowerCase() != 'true' &&
                            data?.service == 'Internet' && (
                                <div>
                                    <a class="hyperlink" href="#" onClick={(e) => handleRedirect(e, 'internettransfer')}>{dataInfo?.transferlabel || t('transfer_data')}
                                    <img src={getImgSrc('/assets/images/right_arrow_red.svg')} className={`ms-1 ${lang === 'en' ? 'arrow-img-en' : 'arrow-img-ar'}`} alt="arrow" />
                                    </a>
                                </div>
                            )
                        }
                        </div>
                    </>
                )
            }
            </div>
           
           </>)

          
         }
         {
             type === 'square' && (<>
             
             <div class="sprint14-2row sprint14-cr-2col">
                <div class="profile_info_desc">
                    <img src={getImgSrc(imagePath, isServerUrl)} alt="icon" width={45} />
                    <div class="s-text me-2">
                        <h5>{data?.rnheader}</h5>
                        {
                            showExtra && (
                                <p class="m-0 p-0"> {data?.packtitle} </p>
                            )
                        }
                    </div>
             </div>

            {
                !data?.isunlimited ? (
                    <div class="sprint14-progress-bar">
                        <div style={{direction: isContainAlphabet(used) ? "ltr" : ""}}>
                            {used} <span> {`${total ? `/ ${total}` : ''}`} </span>
                        </div>
                        <div class="progress" role="progressbar">
                            <div class="progress-bar" style={{ width: `${percentage}%` || '0%', backgroundColor: colorCode }}></div>
                        </div>
                        <p>{dataInfo?.expiresonlabel || t('expires_on')} {data?.endDate}</p>
                    </div>
                ) : (
                    <div className='mt-3 sprint14-progress-bar'>
                        <div className='d-flex align-items-center'>
                            <img src={getImgSrc('/assets/images/infinityunlimited.png')} alt="unlimited" width="30px" /> {t('unlimited')}
                        </div>
                        <p>{dataInfo?.expiresonlabel || t('expires_on')} {data?.endDate}</p>
                    </div>
                )
            }


            {
                infotype === 'data' && showExtra && (
                    <>
                        <hr />
                        <div className='flex_grp_between'>
                        <div>
                            <a class="hyperlink" href="#" onClick={(e) => handleRedirect(e, dataInfo?.btnurl)}>
                                {dataInfo?.btntext}
                                <img src={getImgSrc('/assets/images/right_arrow_red.svg')} class="ms-1" alt="arrow" />
                            </a>
                        </div>

                        {
                            netData?.issharable?.toLowerCase() === 'true' &&
                            netData?.isdisabledatashare.toLowerCase() != 'true' &&
                            data?.service == 'Internet' && (
                                <div>
                                    <a class="hyperlink" href="#" onClick={(e) => handleRedirect(e, 'internettransfer')}>{dataInfo?.transferlabel || t('transfer_data')}
                                    <img src={getImgSrc('/assets/images/right_arrow_red.svg')} className={`ms-1 ${lang === 'en' ? 'arrow-img-en' : 'arrow-img-ar'}`} alt="arrow" />
                                    </a>
                                </div>
                            )
                        }
                        </div>
                    </>
                )
            }
        </div>
             </>)
         }
       
        </>
       
    )
}

export default RemainingInfo